import React, { FC } from "react";
import Button from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import styled from "styled-components";

interface ImageDraftProps {
    draftImage: any;
    onRemoveDraftProfileImage: () => void;
}

const ProfileImageDraft: FC<ImageDraftProps> = ({
    draftImage,
    onRemoveDraftProfileImage,
}) => {
    return (
        draftImage && (
            <Container key={draftImage.id} draftImage={draftImage}>
                <Button
                    onClick={onRemoveDraftProfileImage}
                    sx={{
                        position: "absolute",
                        right: 0,
                        zIndex: 1,
                        p: "4px",
                        minWidth: "unset",
                        color: "grey.500",
                    }}
                >
                    <DeleteIcon />
                </Button>
            </Container>
        )
    );
};

export default ProfileImageDraft;

const Container = styled.div<{
    draftImage?: any;
    key?: string;
}>`
    position: relative;
    height: 200px;
    width: 200px;
    background-size: cover;
    background-position: center;
    margin: auto;
    border-radius: 50%;
    border: 0.1px solid lightgray;
    ${({ draftImage }) =>
        draftImage ? `background-image: url(${draftImage.src}) ` : ""};
`;
